import React, { useState } from 'react';

import swal from 'sweetalert';

import TicketsApi from '../../../Api/CRM/Modules/TicketsApi';
import LotteryTicket from '../../../Api/Models/LotteryTicket';
import confirmationAlert from '../../elements/alerts/confirmationAlert';
import useNumberParams from '../../hooks/useNumberParams';
import useOnce from '../../hooks/useOnce';

import axios from '../../services/MyAxios';

import TicketDetails from './TicketDetails';
import TicketLines from './TicketLines';

function TicketShow() {
    const { id } = useNumberParams();
    const [ticket, setTicket] = useState(new LotteryTicket({}));
    const updateTicket = () => TicketsApi.getById(id).then(setTicket);

    useOnce(updateTicket);

    function handlePayoutClick() {
        confirmationAlert({
            title: 'Are you sure you want to pay out the ticket?',
            onConfirm: () =>
                axios
                    .post(`/crea/api/lottery_ticket/${ticket.token}/payout`)
                    .then(() => {
                        updateTicket();
                        swal({ title: 'Success', text: 'Ticket paid out correctly', icon: 'success' });
                    })
                    .catch(() => {
                        swal({ title: 'Error', text: 'Something went wrong...', icon: 'error' });
                    }),
        });
    }

    return (
        <>
            <TicketDetails ticket={ticket} />
            {ticket.can_be_paid_out && (
                <button type="button" className="btn btn-primary btn-sm mb-3 mr-3" onClick={handlePayoutClick}>
                    Pay out the ticket
                </button>
            )}
            <TicketLines ticketId={id} />
        </>
    );
}

export default TicketShow;
